import { Icon } from 'semantic-ui-react';
import { CheckboxBtn } from '../../financialTables/configuration/fields';
import './advancedSettingsToggle.styles.css';
import { Settings } from 'lucide-react';

type AdvancedSettingsToggleProps = {
    showAdvancedSettings: boolean;
    toggleAdvancedSettings: () => void;
};

const AdvancedSettingsToggle = ({ showAdvancedSettings, toggleAdvancedSettings }: AdvancedSettingsToggleProps) => {
    return (
        <CheckboxBtn
            className="advanced-settings-btn"
            label={<Settings size={18} strokeWidth={1.5} />}
            checked={showAdvancedSettings}
            onChange={toggleAdvancedSettings}
        />
    );
};

export default AdvancedSettingsToggle;
